import React, { useEffect } from "react";
import { Link } from "wouter";
import { canAccessFeature } from "~/functions/Access.js";
import redirect from "~/functions/redirect.js";
import { useDataEnv } from "~/functions/DataEnv.js";
import _ from "lodash";

const PDFPod = ({ podule, feature }) => {
    const dataEnv = useDataEnv();
    const featurePlan = _.get(dataEnv, 'current_account.feature_plan');
    const hasAccess = canAccessFeature(featurePlan, podule);

    useEffect(() => {
        if (!hasAccess) redirect(Routes.path_path('pricing'));
    }, []);

    return (
        <>
            <iframe
                src={`https://docs.google.com/gview?url=${podule.itself}&embedded=true`}
                width="100%"
                height="800px"
            >
            </iframe>

            <div className="site-row m-0">
                <Link to={`/`}>&lt; Back to {feature.navTitle}</Link>
            </div>
        </>
    );
}

export default PDFPod;